import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';

import { AppSettingsService } from '@core/services/app-settings.service';
import { AppComponent } from 'ClientApp/app/app.component';

@Component({
	selector: 'entra-ad-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {

	isAuthenticated: boolean = false;
	environment: string;
	releaseNumber: string;
	userName: string | undefined;

	constructor(
		appSettings: AppSettingsService,
		private msalService: MsalService,
		private router: Router,
		private appComponent: AppComponent
	) {
		const settings = appSettings.getSettings();

		this.environment = settings.Application.Environment;
		this.releaseNumber = settings.Application.ReleaseNumber;
	}

	ngOnInit(): void {
		this.msalService.handleRedirectObservable().subscribe({
			next: (result: AuthenticationResult | null) => {
				if (result && result.account) {
					this.msalService.instance.setActiveAccount(result.account);
					this.appComponent.afterLogin(); 
					this.router.navigate(['/projects']);
				} 
				else if (!this.msalService.instance.getActiveAccount()) {
					this.login();
				}
			},
			error: (error) => {
				console.error('Error during redirect handling:', error);
				this.login();
			},
		});
	}
	
	login(): void {
		this.msalService.loginRedirect({
			scopes: ['User.Read']
		  });
	}
	
	ngOnDestroy(): void {
	}
}